/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type JournalEntriesTable_journalEntryEdges$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PaginatedJournalEntriesContainer_journalEntries$ref: FragmentReference;
declare export opaque type PaginatedJournalEntriesContainer_journalEntries$fragmentType: PaginatedJournalEntriesContainer_journalEntries$ref;
export type PaginatedJournalEntriesContainer_journalEntries = {|
  +journalEntries: {|
    +edges: ?$ReadOnlyArray<?{|
      +cursor: string,
      +$fragmentRefs: JournalEntriesTable_journalEntryEdges$ref,
    |}>
  |},
  +$refType: PaginatedJournalEntriesContainer_journalEntries$ref,
|};
export type PaginatedJournalEntriesContainer_journalEntries$data = PaginatedJournalEntriesContainer_journalEntries;
export type PaginatedJournalEntriesContainer_journalEntries$key = {
  +$data?: PaginatedJournalEntriesContainer_journalEntries$data,
  +$fragmentRefs: PaginatedJournalEntriesContainer_journalEntries$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PaginatedJournalEntriesContainer_journalEntries",
  "type": "Query",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": [
          "journalEntries"
        ]
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "count",
      "type": "Int",
      "defaultValue": 30
    },
    {
      "kind": "LocalArgument",
      "name": "cursor",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "search",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "sortBy",
      "type": "JournalEntrySort",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "statuses",
      "type": "[JournalEntryStatus!]",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "sourceTypes",
      "type": "[JournalSourceType!]",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "startDate",
      "type": "Date",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "endDate",
      "type": "Date",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "journalEntries",
      "name": "__PaginatedJournalEntriesContainer_journalEntries_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "JournalEntryConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "JournalEntryEdge",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "JournalEntry",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "JournalEntriesTable_journalEntryEdges",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c44896eb01689ea345f7e97d7aad4250';
module.exports = node;
